import { makeStyles, Theme } from '@material-ui/core/styles';
import { green, amber } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5),
    maxWidth: '830px',
  },
  topSearchKeywordWrapper: {
    width: '486px',
  },
  popularKeywordWrapper: {
    width: '320px',
  },
  searchKeywordBox: {
    width: '100%',
    height: '512px',
    overflow: 'scroll',
    border: 'solid 1px #e0e0e0',
    marginTop: theme.spacing(1.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  searchKeywordBoxBlocker: {
    position: 'absolute',
    width: '446px',
    backgroundColor: '#f00',
    opacity: 0.5,
  },
  popularKeywordBox: {
    width: '100%',
    height: '480px',
    overflow: 'scroll',
    marginTop: theme.spacing(0.75),
    borderTop: 'solid 1px #e0e0e0',
    borderBottom: 'solid 1px #e0e0e0',
  },
  maxKeywordDesc: {
    color: theme.palette.primary.main,
  },
  maxKeywordDescEmphasized: {
    color: 'red',
  },
  editButton: {
    fontSize: 14,
    fontWeight: 500,
    width: '80px',
    backgroundColor: '#757575', // FIXME: fix predefined value (or palette)
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: '#555',
    },
  },
  deleteButton: {
    textTransform: 'none',
    fontSize: 13,
    color: theme.palette.primary.main,
    fontWeight: 400,
    letterSpacing: 0,
  },
  applyButton: {
    fontSize: 14,
    fontWeight: 500,
  },
  cancelEditButton: {
    fontSize: 14,
    fontWeight: 500,
    marginRight: theme.spacing(0.5),
  },
  durationButton: {
    fontSize: 13,
    fontWeight: 'normal',
    textTransform: 'none',
    letterSpacing: 0,
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  keywordCell: {
    display: 'flex',
    alignItems: 'center',
    height: '48px',
    paddingLeft: theme.spacing(1.875),
    paddingRight: theme.spacing(1.875),
    backgroundColor: theme.palette.background.paper,
  },
  keywordCellEditing: {
    paddingLeft: 0,
  },
  keywordCellBorder: {
    borderBottom: 'solid 1px #e0e0e0',
  },
  keywordDisabled: {
    color: '#a2a2a2',
  },
  keywordFormGroup: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    flexWrap: 'nowrap',
  },
  keywordFormLabel: {
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 14,
  },
  hide: {
    visibility: 'hidden',
  },
  clearButton: {
    color: '#a2a2a2',
  },
  addKeywordInput: {
    paddingTop: theme.spacing(1.75),
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  lateNightKeywordBox: {
    width: '100%',
    height: '231px',
    overflow: 'scroll',
    border: 'solid 1px #e0e0e0',
    paddingTop: '10px',
    paddingLeft: '15px',
    paddingBottom: '13px',
    marginTop: theme.spacing(1.5),
  },
  lateNightKeywordCell: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    height: '35px',
  },
  lateNightKeywordCellLabel: {
    fontSize: 14,
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  description: {
    display: 'block',
    fontSize: 13,
    fontWeight: 500,
    color: '#999',
    maxWidth: 580,
  },
  notify: {
    animation: '$fadeout 7s ease-in-out',
    animationDelay: '0.2s',
    animationIterationCount: 1,
  },
  '@keyframes fadeout': {
    ['0%']: {
      backgroundColor: `${theme.palette.primary.main.toString()}30`,
    },
    ['70%']: {
      backgroundColor: `${theme.palette.primary.main.toString()}15`,
    },
    ['100%']: {
      backgroundColor: `${theme.palette.primary.main.toString()}00`,
    },
  },
}));

export default useStyles;
